const VERSION = 1;

const RNWV = () =>
  typeof window !== "undefined" &&
  window.ReactNativeWebView &&
  typeof window.ReactNativeWebView.postMessage === "function";

const uuid = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

const safeStringify = (obj) => {
  try {
    return JSON.stringify(obj);
  } catch {
    return null;
  }
};

export const nativeBridge = {
  isWrapper() {
    return !!RNWV();
  },

  /**
   * Mensaje de comunicación con dispositivos cuando se ejecuta mediante el wrapper en tiendas:
   * - data.type en raíz
   * - campos en raíz (phoneNumber, email, base64, etc.)
   * El campo v/id es para debug (se puede ignorar)
   */
  send(type, payload = {}) {
    if (!RNWV()) return false;

    const msg = {
      v: VERSION,
      id: uuid(),
      type,
      ...payload,
    };

    const json = safeStringify(msg);
    if (!json) return false;

    try {
      window.ReactNativeWebView.postMessage(json);
      return true;
    } catch {
      return false;
    }
  },

  debugWrapper(extra = {}) {
    return this.send("debugWrapper", {
      isNativeApp: typeof window !== "undefined" ? window.isNativeApp : null,
      hasRNWebView: typeof window !== "undefined" ? !!window.ReactNativeWebView : false,
      href: typeof window !== "undefined" ? window.location.href : null,
      ...extra,
    });
  },

  // Delega la apertura de PDFs al weapper (compact) 
  // @deprecated
  openPdfBase64(base64, filename) {
    return this.send("openPdfBase64", { base64, filename });
  },

  // Delega la apertura de PDFs al weapper
  openPdf(docType, id) {
    return this.send("openPdf", { docType, id });
  },

  // Auth para que el wrapper pueda realizar consultas a las API mediante el uso de la sesión compartida con la app web
  setAuth(accessToken) {
    return this.send("setAuth", { accessToken });
  },

  call(phoneNumber) {
    return this.send("call", { phoneNumber });
  },

  email(email) {
    return this.send("email", { email });
  },
};

export default nativeBridge;
